import { DownloadCloudIcon } from "lucide-react";
import React from "react";
import { DownloadDocumentButton } from "./DownloadDocumentButton";

export const DownloadDocumentIconButton: React.FC<
  React.ComponentProps<typeof DownloadDocumentButton>
> = (props) => (
  <DownloadDocumentButton StartIcon={DownloadCloudIcon} iconOnly {...props} />
);
